import * as THREE from 'three';
import { useRef } from 'react';
import { useFrame, useThree, useLoader } from '@react-three/fiber';


export default function SimpleLensFlare({ position = [10, 10, -20], size = 15, emissiveColor = [0.5, 0.5, 0.5] }) {
  const planeRef = useRef();
  const materialRef = useRef();
  const { camera } = useThree();
  // Use the new imported lens flare texture

  const texture = useLoader(THREE.TextureLoader, '/lensflare.webp');
  if (texture) texture.flipY = true;


  // Animate opacity for a subtle flicker
  useFrame(({ camera, clock }) => {
    const t = clock.getElapsedTime();
    // Flicker between 0.7 and 1.0 using a sine wave and some randomness
    const base = 0.85 + 0.15 * Math.sin(t * 1.2); // slower flicker
    const noise = 0.04 * Math.sin(t * 3.5 + Math.sin(t * 1.2));
    const flicker = Math.max(0.7, Math.min(1, base + noise));
    if (materialRef.current) {
      materialRef.current.opacity = flicker;
    }
    if (planeRef.current) {
      // Scale up and down in sync with flicker
      const scale = 1 + (flicker - 0.85) * 0.18; // reduced scale range
      planeRef.current.scale.set(scale, scale, 1);
      planeRef.current.rotation.z -=0.001 
    }
  });

  return (
    <mesh ref={planeRef} position={position} renderOrder={9999}>
      <planeGeometry args={[size*1.45, size*1]} />
      <meshStandardMaterial
        ref={materialRef}
        map={texture}
        alphaMap={texture}
        emissiveMap={texture}
        emissive={emissiveColor}
        transparent
        opacity={1}
        blending={THREE.AdditiveBlending}
        depthWrite={false}
        depthTest={false}
        toneMapped={false}
      />
    </mesh>
  );
}

